import { Component } from 'react';
import I18n from 'I18n';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Flex } from 'foundations-components/components/Flex';
import ViewSenderPopoverContent from './ViewSenderPopoverContent';
import ViewSenderAvatar from './ViewSenderAvatar';
import { ButtonWithBranding } from '../ButtonWithBranding';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ViewSender extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      senderOpen: false
    };
    this.handleToggleSender = () => {
      this.setState(({
        senderOpen
      }) => ({
        senderOpen: !senderOpen
      }));
    };
  }
  render() {
    const {
      meetingLink,
      user,
      brandingColor
    } = this.props;
    const {
      senderOpen
    } = this.state;
    if (!user) {
      return null;
    }
    const {
      email
    } = user;
    return /*#__PURE__*/_jsx(Popover, {
      arrowSize: "none",
      open: senderOpen,
      closeOnOutsideClick: true,
      onOpenChange: e => this.setState({
        senderOpen: e.target.value
      }),
      placement: "bottom left",
      marginBlockStart: "300",
      content: /*#__PURE__*/_jsx(ViewSenderPopoverContent, {
        meetingLink: meetingLink,
        email: email,
        firstName: user.firstName,
        lastName: user.lastName,
        brandingColor: brandingColor
      }),
      children: /*#__PURE__*/_jsx(ButtonWithBranding, {
        "aria-label": I18n.text('a11y.senderProfile', {
          email
        }),
        onClick: this.handleToggleSender,
        brandingColor: brandingColor,
        hasBorder: false,
        buttonPaddingBlock: "0px",
        buttonPaddingInline: "0px",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          justifyContent: "center",
          children: [/*#__PURE__*/_jsx(Flex, {
            marginInlineEnd: "200",
            children: /*#__PURE__*/_jsx(ViewSenderAvatar, {
              email: email,
              size: "sm"
            })
          }), /*#__PURE__*/_jsx(DownIcon, {
            size: "200"
          })]
        })
      })
    });
  }
}